import { IEnsaioAnalise } from "@/interfaces/IEnsaioAnalise";
import { createAction } from "@reduxjs/toolkit";

const sync = createAction("ENSAIO_ANALISE/sync", (items: IEnsaioAnalise[]) => ({
  payload: { items },
}));

export const ensaioAnaliseAction = {
  sync,
};
